import { FilterType } from '@iupics/apiz-grid';

/** Get the angular componentName from ad_reference_id */
// eslint-disable-next-line complexity
function getComponentNameFromReference(referenceId: number, fieldLength = 0): string {
  switch (referenceId) {
    /* Display Type 14	Text	*/
    /* Display Type 23	BLOB	*/
    /* Display Type 34	Memo	*/
    /* Display Type 36	CLOB	*/
    case 14:
    case 23:
    case 34:
    case 36:
      return 'InputTextareaUiComponent';
    /* Display Type 10	String	*/
    /* Display Type 38	File Path	*/
    /* Display Type 39 File Name	*/
    /* Display Type 40	URL	*/
    case 10:
    case 38:
    case 39:
    case 40:
      if (fieldLength > 254) {
        return 'InputTextareaUiComponent';
      } else {
        return 'InputTextUiComponent';
      }
    /* Display Type 11	Integer	*/
    /* Display Type 12	Amount	*/
    /* Display Type 13	ID	*/
    /* Display Type 22	Number	*/
    /* Display Type 29	Quantity	*/
    /* Display Type 37	CostPrice	*/
    case 11:
    case 12:
    case 13:
    case 22:
    case 29:
    case 37:
      return 'InputNumberUiComponent';
    /* Display Type 15	Date	*/
    /* Display Type 16	DateTime	*/
    case 15:
    case 16:
      return 'CalendarUiComponent';
    /* Display Type 24	Time	*/
    case 24:
      return 'InputTimeUiComponent';
    /* Display Type 17	List	*/
    /* Display Type 18	Table	*/
    /* Display Type 19	TableDir	*/
    /* Display Type 25	Account	*/
    /* Display Type 30	Search	*/
    /* Display Type 31	Locator	*/
    /* Display Type 35	PAttribute	*/
    /* Display Type 42	PrinterName	*/
    case 17:
    case 18:
    case 19:
    case 25:
    case 30:
    case 31:
    case 35:
    case 42:
      return 'AutocompleteUiComponent';
    /* Display Type 20	YN	*/
    case 20:
      return 'InputSwitchUiComponent';
    /* Display Type 21	Location	*/
    case 21:
      return 'InputLocationUiComponent';
    /* Display Type 28	Button	*/
    /* Display type 46 Link Button */
    case 28:
    case 46:
      return 'ButtonUiComponent';
    /* Display Type 32 Image	*/
    case 32:
      return 'InputImageUiComponent';
    /* Display Type 45 Upload File */
    case 45:
      return 'InputFileUiComponent';
    /* Display Type 77 Comment */
    case 77:
      return 'CommentUiComponent';
    /* Display Type 78 Text HTML */
    case 78:
      return 'InputTextHtmlUiComponent';
    /* Display Type 79 Text JSON */
    case 79:
      return 'InputJsonUiComponent';
    /* Display Type 80 Icon */
    case 80:
      return 'InputIconUiComponent';
    /* Display Type 27	Color */
    case 27:
      return 'InputColorUiComponent';
    default:
      return undefined;
  }
}

/** Get the filterType from ad_reference_id */
function getFilterTypeFromReference(referenceId: number): FilterType {
  return referenceId === 24
    ? FilterType.TIME
    : referenceId === 15 || referenceId === 16
      ? FilterType.DATE
      : (referenceId >= 17 && referenceId <= 19) ||
          referenceId === 30 ||
          referenceId === 42 ||
          referenceId === 27 ||
          referenceId === 31 ||
          referenceId === 25
        ? FilterType.SET
        : referenceId === 11 ||
            referenceId === 12 ||
            referenceId === 13 ||
            referenceId === 22 ||
            referenceId === 29 ||
            referenceId === 37 ||
            referenceId === 21
          ? FilterType.NUMBER
          : FilterType.TEXT;
}

/** Get the sql type from ad_reference_id */
function getDataTypeFromReference(referenceId: number): string {
  switch (referenceId) {
    case 11:
    case 12:
    case 13:
    case 22:
    case 29:
    case 37:
      return 'number';
    case 15:
    case 16:
      return 'date';
    default:
      return 'text';
  }
}

const ReferenceUtils = {
  getFilterTypeFromReference,
  getComponentNameFromReference,
  getDataTypeFromReference,
} as const;

export { ReferenceUtils };
